package com.routexk.quiz.di

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.remember
import com.routexk.quiz.data.http.HttpClientFactory
import io.ktor.client.*

class AppContainer {
    val defaultHttpClient: HttpClient by lazy { HttpClientFactory.createDefault() }

    private var authenticatedClient: HttpClient? = null

    fun createAuthenticatedClients(token: String) {
        authenticatedClient?.close()
        authenticatedClient = HttpClientFactory.createAuthenticated(token)
    }

    fun getAuthenticatedClient(): HttpClient {
        return authenticatedClient
            ?: throw IllegalStateException("Authenticated client not initialized. Call createAuthenticatedClients(token) first.")
    }

    fun clearAuthenticatedClients() {
        authenticatedClient?.close()
        authenticatedClient = null
    }

    fun dispose() {
        defaultHttpClient.close()
        clearAuthenticatedClients()
    }
}

val LocalAppContainer = compositionLocalOf<AppContainer> {
    error("AppContainer not provided")
}

@Composable
fun ProvideAppContainer(
    container: AppContainer = remember { AppContainer() },
    content: @Composable () -> Unit
) {
    CompositionLocalProvider(LocalAppContainer provides container) {
        content()
    }
}
